import i18n from '../../i18n';

export const modalStyles = {
  overlay: {
    zIndex: 10,
    backgroundColor: 'rgba(255, 255, 255, 0.98)',
  },
  content: {
    background: 'rgba(255, 255, 255, 0)',
    border: 'none',
    padding: '0',
    top: '0',
    left: '0',
    right: 'auto',
    bottom: 'auto',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
};

export const FILTERS = {
  ALL: 'ALL',
  BUILDINGS: 'BUILDINGS',
  SUB_REGIONS: 'SUB_REGIONS',
  REGIONS: 'REGIONS',
  STREETS: 'STREETS',
};

export const getFiltersPlaceholder = (t) =>
  new Map([
    [
      FILTERS.ALL,
      [
        t('components.searchFullscreen.constants.all1'),
        t('components.searchFullscreen.constants.all1'),
      ],
    ],
    [
      FILTERS.REGIONS,
      [
        t('components.searchFullscreen.constants.regions'),
        t('components.searchFullscreen.constants.regions'),
      ],
    ],
    [
      FILTERS.SUB_REGIONS,
      [
        t('components.searchFullscreen.constants.sub_regions'),
        t('components.searchFullscreen.constants.sub_regions'),
      ],
    ],
    [
      FILTERS.BUILDINGS,
      [
        t('components.searchFullscreen.constants.buildings'),
        t('components.searchFullscreen.constants.buildings'),
      ],
    ],
    [
      FILTERS.STREETS,
      [
        t('components.searchFullscreen.constants.streets'),
        t('components.searchFullscreen.constants.streets'),
      ],
    ],
  ]);



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/constants.js